import React from 'react';
import { Link } from 'gatsby';
import InstagramIcon from '../../icons/b2b-instagram.svg';
import LinkedInIcon from '../../icons/b2b-linkedin.svg';
import TwitterIcon from '../../icons/b2b-twitter.svg';
import YoutubeIcon from '../../icons/b2b-youtube.svg';
import PFFBusinessIcon from '../../icons/pff-for-business.svg';
import PiaggioGroupIcon from '../../icons/piaggio-group.svg';

const KiloMobileFooter = () => (
  <footer
    className="md:hidden bg-gradient-to-b from-navy-600 from-0% via-navy-400 via-45% to-navy-600 to-100% text-white p-8"
  >
    <div>
      <div>
        <div className="flex flex-row justify-between items-center">
          <PFFBusinessIcon className="h-[35px] w-auto relative" />
          <Link
            to="/business/contact"
            className="bg-cerulean-400 max-w-[140px] lg:max-w-[200px] font-brown tracking-[2.16px] my-3 lg:my-10
              text-white text-[12px] lg:text-[18px] px-5 lg:px-8 py-2 hover:brightness-75 uppercase rounded-[28px]"
          >
            Contact Us
          </Link>
        </div>

        <div className="flex flex-row justify-center lg:hidden mb-4 mt-7 md:mb-0 md:mr-10">
          <a href="https://www.linkedin.com/company/piaggiofastforward" className="mx-2">
            <LinkedInIcon className="w-auto h-[20px]" />
          </a>
          <a href="https://www.instagram.com/piaggiofastforward/?hl=en" className="mx-2">
            <InstagramIcon className="w-auto h-[20px]" />
          </a>
          <a href="https://twitter.com/piaggiofastfwd?lang=en" className="mx-2">
            <TwitterIcon className="w-auto h-[20px]" />
          </a>
          <a href="https://www.youtube.com/c/PiaggioFastForward" className="mx-2">
            <YoutubeIcon className="w-auto h-[20px]" />
          </a>
        </div>
        <div className="flex justify-between text-[15px] my-8 font-brown font-bold">
          <Link to="/support" className="mx-2">
            Support
          </Link>
          <Link to="/privacy-policy" className="mx-2">
            Privacy Policy
          </Link>
          <Link to="/press" className="mx-2">
            Press Kit
          </Link>
        </div>
        <div className="flex flex-row justify-between">
          <span className="text-[12px] lg:text-[15px] lg:hidden font-brown text-beige-300 relative tracking-[1.8px]">
            © 2024 Piaggio Fast Forward.
            <br /> All Rights Reserved.
          </span>
          <div>
            <PiaggioGroupIcon className="w-auto h-[34px] mb-2" />
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default KiloMobileFooter;
